import intl from "react-intl-universal";
import {TaskListModelType} from "../../stores/taskLists/TaskListModel";
import {TaskListUnitModelType} from "../../stores/taskLists/TaskListUnitModel";
import {deleteTaskList as deleteTaskListRequest} from "../../stores/taskLists/requests/deleteTaskList";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";

import {snackBarRef} from "../../stores/snackbarRef";



export const deleteTaskList = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    taskListModel: TaskListModelType,
    taskListUnitModel: TaskListUnitModelType,
) => {
    await deleteTaskListRequest(dataClientService, authService, taskListUnitModel.id, taskListModel.id, taskListUnitModel.version);
    snackBarRef.current!.enqueueSnackbar({
        message: intl.get('taskList.delete.success').d('List deleted successfully'),
    })
}
